import { Node, mergeAttributes } from '@tiptap/core'
import { NodeViewWrapper, ReactNodeViewProps, ReactNodeViewRenderer } from '@tiptap/react'

import { Text } from '@/components/ui/Text'

export function QuoteEmbedView(props: ReactNodeViewProps) {
  const { node } = props

  const embedId = String(node.attrs.embedId ?? '')

  return (
    <NodeViewWrapper
      as="div"
      className="my-2 flex items-center rounded-md border border-border bg-muted px-3 py-2"
      data-embed-id={embedId}
      data-testid="artifact-md-editor-quote-embed"
    >
      <Text as="span" size="sm" color="muted">
        Quote {embedId}
      </Text>
    </NodeViewWrapper>
  )
}

export const QuoteEmbedNode = Node.create({
  name: 'quoteEmbed',
  group: 'block',
  atom: true,
  selectable: true,
  draggable: false,

  addAttributes() {
    return {
      embedId: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-embed-id'),
        renderHTML: (attributes) => {
          return { 'data-embed-id': attributes.embedId }
        },
      },
    }
  },

  parseHTML() {
    return [{ tag: 'div[data-quote-embed]' }]
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-quote-embed': '' })]
  },

  addNodeView() {
    return ReactNodeViewRenderer(QuoteEmbedView)
  },
})
